import TYPES from '../types';

export default () => {
  return {
    type: TYPES.CLOSE_MODAL,
  };
};
